// The module cache
var __webpack_module_cache__ = {};

// The require function
function __webpack_require__(moduleId) {

	        // webpack-livereload-plugin
	        (function() {
	          if (typeof window === "undefined") { return };
	          var id = "webpack-livereload-plugin-script-bfe7c7cd0d2ed5c3";
	          if (document.getElementById(id)) { return; }
	          var el = document.createElement("script");
	          el.id = id;
	          el.async = true;
	          el.src = "//" + location.hostname + ":35729/livereload.js";
	          document.getElementsByTagName("head")[0].appendChild(el);
	          console.log("[Live Reload] enabled");
	        }());
	        // Check if module is in cache
	var cachedModule = __webpack_module_cache__[moduleId];
	if (cachedModule !== undefined) {
		return cachedModule.exports;
	}
	// Create a new module (and put it into the cache)
	var module = __webpack_module_cache__[moduleId] = {
		// no module.id needed
		// no module.loaded needed
		exports: {}
	};

	// Execute the module function
	__webpack_modules__[moduleId](module, module.exports, __webpack_require__);

	// Return the exports of the module
	return module.exports;
}

// expose the modules object (__webpack_modules__)
__webpack_require__.m = __webpack_modules__;

